import React, { Component } from 'react';
import { createGeneralContractor } from 'components/admin/general-contractors/store/actions';
import GeneralContractorForm from 'components/admin/general-contractors/GeneralContractorForm';
import { connect } from 'react-redux';

class NewGeneralContractor extends Component {
  handleOnSubmit = (values) => {
    this.props.dispatch(createGeneralContractor(values));
  };

  render() {
    return (
      <div>
        <GeneralContractorForm onSubmit={this.handleOnSubmit} />
      </div>
    );
  }
}

export default connect((state) => {
  return {};
})(NewGeneralContractor);



// WEBPACK FOOTER //
// ./src/components/admin/general-contractors/NewGeneralContractor.js